import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty } from 'lodash';
import { ColumnSevenLgSixMd } from './styles/Column.styled';
import { DWTCContext } from '../utils/context';
import {
  ToggleTag,
  CardOneColumn,
  CardOneColumnSec,
  ButtonCard,
  OneColumnBox,
  CardWrapperOne,
  CardOneHeader,
  CardBodyOneColumn,
  BlockCardImage,
} from './styles/FilterTabBlock.styled';
import { getTranslationByKey } from '../helpers/translation-helper';

export default function ExperiencesCardMedium({ data, dir, onClick, experience }) {
  const websiteName = dir === 'rtl' ? 'الموقع الالكتروني' : 'Website';
  const googleMap = dir === 'rtl' ? 'الخريطة' : 'Google maps';
  const isOpen = experience === data.title;
  const { translations } = React.useContext(DWTCContext);

  return (
    <ColumnSevenLgSixMd className="medium-card">
      <OneColumnBox>
        <CardWrapperOne>
          <BlockCardImage>
            {isEmpty(data.image) || (
              <LazyLoadImage
                src={data.image.url}
                alt={data.image.name}
                placeholderSrc={data.image ? `${data.image.url}?width=50&quality=50` : null}
                effect="blur"
              />
            )}{' '}
          </BlockCardImage>
          <div className="accordion-wrapper" dir={dir}>
            <ToggleTag
              className={`accordion-title ${isOpen ? 'open' : ''}`}
              onClick={() => onClick(data.title)}
              dir={dir}
            />
            <CardOneColumn className={`accordion-item ${!isOpen ? 'collapsed' : 'active'}`}>
              <CardOneColumnSec>
                <CardOneHeader dir={dir}>
                  <span dir={dir}>{getTranslationByKey(translations, data.subCategory)}</span>
                  <h3 dir={dir}>{data.title}</h3>
                </CardOneHeader>

                <CardBodyOneColumn dir={dir} className="onecolumn_card">
                  <h4>{data.subtitle}</h4>
                  <p>{data.description}</p>
                  <ButtonCard dir={dir}>
                    {isEmpty(data.experienceWebsite) || (
                      <a href={data.experienceWebsite} target="_blank" rel="noreferrer" dir={dir}>
                        {websiteName}
                      </a>
                    )}
                    {isEmpty(data.googleMaps) || (
                      <a href={data.googleMaps} target="_blank" rel="noreferrer" dir={dir}>
                        {googleMap}
                      </a>
                    )}
                  </ButtonCard>
                </CardBodyOneColumn>
              </CardOneColumnSec>
            </CardOneColumn>
          </div>
        </CardWrapperOne>
      </OneColumnBox>
    </ColumnSevenLgSixMd>
  );
}
